<script setup>
const props = defineProps({
  title: {
    type: String,
    required: false,
    default: '',
  },
  expandedOnMount: {
    type: Boolean,
    default: false,
  },
  // inline, underlined, block-grey, block-transparent
  theme: {
    type: String,
    required: false,
    default: 'inline',
  },
})

const expanded = ref(false)

onMounted(() => {
  expanded.value = props.expandedOnMount
})
</script>

<template>
  <div
    class="flex flex-col"
    :class="{
      'w-full rounded-lg bg-gray-50 px-6 py-5': theme === 'block-grey',
      'w-full rounded-lg border border-gray-800 p-6':
        theme === 'block-transparent',
      'border-b border-gray-400 py-3': theme === 'underlined',
    }"
  >
    <button
      class="flex items-center justify-between"
      @click.prevent="expanded = !expanded"
    >
      <div
        class="text-left"
        :class="{
          'text-sm font-bold text-gray-900': theme === 'inline',
          'text-lg font-semibold text-gray-800': theme === 'underlined',
          'text-lg font-semibold text-secondary': theme === 'block-grey',
        }"
      >
        <slot name="title"
          ><span class="text-sm font-bold text-gray-900">{{
            title
          }}</span></slot
        >
      </div>
      <figure
        class="flex items-center justify-center"
        :class="{
          'h-10 w-10 rounded-full bg-secondary  text-white':
            theme === 'block-grey',
          'h-6 w-6 rounded-full bg-secondary text-white':
            theme === 'block-transparent',
          'text-gray-700': theme === 'underlined',
        }"
      >
        <IconChevronDown
          class="h-[6px] w-[10px] transition-transform duration-300"
          :class="{ '-rotate-180': expanded }"
        />
      </figure>
    </button>
    <HeightTransition>
      <div
        v-if="expanded"
        :class="{ 'text-lg text-gray-700': theme === 'block-grey' }"
      >
        <div
          :class="{
            'pt-4': theme === 'inline',
            'pb-1 pt-[18px]': theme === 'block-grey',
          }"
        >
          <slot name="content"></slot>
        </div>
      </div>
    </HeightTransition>
  </div>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}

.v-enter,
.v-leave-to {
  transform: translateY(-30%);
  opacity: 0;
}
</style>
